import customFetch from '../../../utils/customFetch';

export const getClientInfo = id => {
  return customFetch('/Company/CompanyInfo', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id }),
  });
};

export const getStaffAll = (keyword = '', numberStaff = 30) => {
  return customFetch('/Staff/GetAll', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      IsSelectionList: true,
      Showing: 'active',
      curPage: 1,
      keyword: keyword,
      numItemPerPage: numberStaff,
    }),
  });
};

export const getCountryList = () => {
  return customFetch('/Company/Country_GetList', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  });
};

export const getCityList = (id = 16) => {
  return customFetch('/Company/City_GetList', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ countryId: id }),
  });
};

export const getClientOfficer = () => {
  return customFetch('/Company/GetStaffs', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({getAll : true}),
  });
};

export const getLookupConfig = () => {
  return customFetch('/Company/GetLookUpConfig', {
    method: 'POST',
    headers: { 'Content-type': 'application/json' },
    body: JSON.stringify({ type: 'client' }),
  });
};

export const getStaff = () => {
  return customFetch('/Staff/GetStaffs', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ camelCaseResult: true }),
  });
};

export const getBussinesUnit = () => {
  return customFetch('/BusinessUnit/GetBusinessUnits', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ camelCaseResult: true }),
  });
};

export const uploadFileTemplate = body => {
  return customFetch('/File/UploadFileTemp', {
    method: 'POST',
    body,
  });
};

export const saveCompany = clientParam => {
  return customFetch('/Company/Save', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(clientParam),
  });
};

export const checkDuplicateCompany = (id, name) => {
  return customFetch('/Company/CheckDuplicateName', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, name }),
  });
};

export const viewBookingHistory = (
  clientId,
  sortKeyBooking,
  sortDirectionBooking,
) => {
  return customFetch(
    `/Company/GetBookingHistory?clientId=${clientId}&sortBy=${sortKeyBooking}&sortDirection=${sortDirectionBooking
      .replace('ending', '')
      .toUpperCase()}`,
    {
      method: 'GET',
    },
  );
};

//
export const getAllSpecialist = body => {
  return customFetch('/MedicalDoctor/GetAll', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
};

export const getRegisteredSpecialistDetails = arrId => {
  return customFetch('/MedicalDoctor/GetDoctorByIdList', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(arrId),
  });
};
export const getRegisteredSpecialists = cId => {
  return customFetch('/Company/GetCompanyDoctorIds', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ cId }),
  });
};

export const registeredSpecialists = (cId, doctors) => {
  return customFetch('/Company/UpdateCompanyDoctor', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ cId, doctors }),
  });
};
